import { render } from "./FacturacionView.vue?vue&type=template&id=8af1ee64"
import script from "./FacturacionView.vue?vue&type=script&lang=js"
export * from "./FacturacionView.vue?vue&type=script&lang=js"

import "./FacturacionView.vue?vue&type=style&index=0&id=8af1ee64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__